import React, { Suspense, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { getFrontendProperties } from '../../definitions/Config';
import { AccessTokenContext } from '../../context/AccessTokenContext';
import DLL from '@visma/formula/lib/dll';
import Loader from '../Loader';
import AfterDraftSave from './AfterDraftSave';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { FormattedMessage, IntlProvider } from 'react-intl';
import FormDraftInfo from './FormDraftInfo';
import Api from '../../api/Api';
import Logger from '../../utils/Logger';
import Messages from '../../lang/messages.fi.json';
import { useSnackbar } from "notistack";
import ReturnDialog from "./ReturnDialog";
import {useDispatch, useSelector} from "react-redux";
import {notificationSelector} from "../../data/selector";
import {FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION} from "../../definitions/NotificationConstants";
import {doRequestDismissNotifications} from "../../data/notification/actions";
import {isFormAttachment, isValidFormAttachmentPayload} from "../../utils/FormulaUtils";
import FormSubmitModal from "./FormSubmitModal";
import FormErrorModal from "./FormErrorModal";

const FormulaComponent = ({
  formId,
  formResponseId,
  formulaUrl,
  accessToken,
  reviewForm,
  onPreSubmit,
  onPostSubmit,
}) => {
  let review = reviewForm;
  const [buttonDisabled, setButtonDisabled] = React.useState(false);

  async function assignForm(props) {
    setButtonDisabled(true);
    const response = await Api.assignQuestionnaireOt({
      formIdRevLatest: props.assignFormId,
      formTitle: props.assignFormTitle,
    });
    if (response === true) {
      enqueueSnackbar('Lomake kohdistettu', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar('Lomakkeen kohdistus epäonnistui', {
        variant: 'error',
      });
    }
    setButtonDisabled(false);
    return response;
  }
  const config = DLL.useAtomicForm(formId);
  const draftSave = config?.draftSave;
  const { enqueueSnackbar } = useSnackbar();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [returnDialogOpen, setReturnDialogOpen] = React.useState(false);
  const handleModal = (response) => {
    setModalOpen(response?.attributes?.id ? true : false);
  };
  if (review) {
    review =
      config?.meta?.allowEditAnswers === undefined
        ? true
        : !config?.meta?.allowEditAnswers;
  }
  const forceReview = review === undefined ? false : review;
  return (
    <div className="not-aui formula">
      <IntlProvider locale="fi-FI" messages={Messages}>
        <DLL.Formula
          className="not-aui formula"
          axios={(axios) => {
            axios.defaults.baseURL = formulaUrl + '/api';
            if (accessToken) {
              axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
            } else {
              delete axios.defaults.headers.common.Authorization;
            }
          }}
          layer={0}
          forceReview={forceReview}
          afterDraftSave={(response) => handleModal(response)}
          id={
            formId.includes('latest')
              ? `fm_${config._id}_${config._rev}`
              : formId
          }
          {...(draftSave ? { dataIsDraft: true } : {})}
          {...(onPostSubmit
            ? { onPostSubmit: onPostSubmit, review: false }
            : {})}
          {...(onPreSubmit
            ? { onPreSubmit: onPreSubmit }
            : {})}
          dataId={formResponseId}
          fillProps={{
            disableElementButtons: buttonDisabled,
            disableResetFormdata: true,
            disablePrint: true,
            actions: (
              <Button
                variant="outlined"
                onClick={() => setReturnDialogOpen(true)}
              >
                <FormattedMessage id="questionnaire.formula.return" />
              </Button>
            ),
          }}
          buttonActions={{
            assignForm: (props) => assignForm(props),
          }}
          customMessages={{
            submit: <FormattedMessage id={config.meta.preview ? "assignedForm.preview.submit" : "assignedForm.submit"} defaultMessage="Esikatsele" />,
            confirmDialogSendButton: <FormattedMessage id="assignedForm.confirmDialog.submit" defaultMessage="Lähetä" />
          }}
          reviewProps={{
            showSuccessText: forceReview === false,
            highlightSuccessText: true,
            actions: (
              <Button variant="outlined" component={Link} to="/questionnaires">
                <FormattedMessage id="return" />
              </Button>
            ),
          }}
        />
        <AfterDraftSave
          open={modalOpen}
          setOpen={setModalOpen}
          title={config?.title}
        />
        <ReturnDialog open={returnDialogOpen} setOpen={setReturnDialogOpen} />
      </IntlProvider>
    </div>
  );
};
const { id: module_id } = module;
const logger = Logger(module_id);
const FormResponse = (props) => {
  const { formId, formResponseId, reviewForm } = props.match.params;
  const [form, setForm] = React.useState();
  const [showFormSubmitModal, setShowFormSubmitModal] = React.useState(false);
  const [showFormErrorModal, setShowFormErrorModal] = React.useState(false);
  const accessTokenState = useContext(AccessTokenContext);
  const { accessToken } = accessTokenState;
  const notifications = useSelector(notificationSelector);
  const dispatch = useDispatch();
  const config = DLL.useAtomicForm(formId);
  const getAssignedForms = async () => {
    try {
      const response = await Api.getAssignedForms();
      if (response) {
        setForm(
          response.find((obj) => {
            return obj.formResponseId === formResponseId;
          })
        );
      }
    } catch (error) {
      logger.error(error);
    }
  };
  useEffect(() => {
    getAssignedForms();
  }, []);

  useEffect(() => {
    if(form) {
      // Check if questionnaire has ever been opened
      if ( form.questionnaireOpened === null || form.questionnaireOpened === false ) {
        form.questionnaireOpened = true;
        Api.updateFormAssignment(form);

        // If questionnaire hasn't been opened, there is a possibility it can have an active notification
        const foundRelatedNotification = notifications.data.find(
            n => n.notificationKey === `${FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION}_${form.id}`);

        // If notification exists, request dismiss
        if(foundRelatedNotification) {
          dispatch(doRequestDismissNotifications([`${FORMULA_QUESTIONNAIRE_PAGE_NOTIFICATION}_${form.id}`]));
        }
      }
    }
  }, [form]);

  const redirectToFormView = (...args) => {
    if (config && config?.meta?.kuvaliite === true) {
      if (isFormAttachment(config)) {
        if (isValidFormAttachmentPayload(args[1]?.values)) {
          setShowFormSubmitModal(true);
        }
      }
    } else {
      props.history.replace(
          '/questionnaires/view/' + form?.id + '?showSubmitConfirmation=true'
      );
    }
  };

  const confirmRedirect = () => {
    props.history.replace('/questionnaires');
  };

  const onPreSubmitWithValidation = async (...args) => {
    let shouldSubmit = true;

    if (isFormAttachment(config)) {
      if (!isValidFormAttachmentPayload(args[0]?.formData)) {
        shouldSubmit = false;
      }
    }

    if (!shouldSubmit) {
      setShowFormErrorModal(true);
    }
    return shouldSubmit;
  }

  const formulaUrl = getFrontendProperties().questionnaireFormulaUrl;

  return (
    <Suspense fallback={<Loader />}>
      <div className="ot-mainview">
        <div aria-live="polite" className="otpro-content">
          <div className="otpro-questionnaire">
            <h1>
              {reviewForm ? (
                <FormattedMessage id="questionnaire.formula.view.title" />
              ) : (
                <FormattedMessage id="questionnaire.formula.fill.title" />
              )}
            </h1>
            {form && <FormDraftInfo form={form} />}
            <div className="not-aui formula">
              <FormulaComponent
                formulaUrl={formulaUrl}
                accessToken={accessToken}
                formId={formId}
                formResponseId={formResponseId}
                reviewForm={reviewForm}
                onPreSubmit={onPreSubmitWithValidation}
                onPostSubmit={redirectToFormView}
              />
            </div>
          </div>
        </div>
        <FormSubmitModal confirmRedirect={confirmRedirect} isOpen={showFormSubmitModal} />
        <FormErrorModal closeModal={() => setShowFormErrorModal(false)} isOpen={showFormErrorModal} />
      </div>
    </Suspense>
  );
};

export default withRouter(FormResponse);
